import { render, staticRenderFns } from "./xsorderDetailList.vue?vue&type=template&id=0fc12199"
import script from "./xsorderDetailList.vue?vue&type=script&lang=js"
export * from "./xsorderDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports